import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchSales, fetchOrder, apiURL } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  getFromToDate4AcYear,
  validatedate_min_max,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CustomerDateWiseSales from "./CustomerDateWiseSales";
import ResetDate from "../images/resetdate.png";

class OrderList extends Component {
  state = {
    Company: [],
    Customer: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_ordersrno", label: "Order No" },
      { id: "dat_orderdateDMY", label: "Date" },
      { id: "vac_customer", label: "Customer" },
      { id: "vac_referencename", label: "Reference Name", hide: true },
      { id: "vac_ledgername", label: "Delivery person Name" },
      { id: "dec_discamt", label: "Discount Amt", hide: true },
      { id: "dec_taxable", label: "Taxable", hide: true },
      { id: "dec_cgst", label: "CGST", hide: true },
      { id: "dec_sgst", label: "SGST", hide: true },
      { id: "dec_igst", label: "IGST", hide: true },
      { id: "dec_grandtotal", label: "Grand Total", hide: true },
      { id: "dec_roundoff", label: "Round Off", hide: true },
      { id: "dec_totalamount", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
      { id: "bint_acid", label: "bint_acid", hide: true },
      { id: "vac_company", label: "vac_company", hide: true },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "OrderList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "OrderList:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
        visiblecondition: [
          { colID: "DisableDelete", value: false, relationalOperator: "==" },
        ],
      },
    ],
    searchData: {
      bint_ordersrno: "",
      dat_orderdateDMY: "",
      vac_customer: "",
      vac_ledgername: "",
      dec_totalamount: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    keyColumn: [
      "bint_ordersrno", //0
      "dat_orderdateDMY", //1
      "vac_customer", //2
      "vac_referencename", //3
      "vac_ledgername", //4
      "dec_discamt", //5
      "dec_taxable", //6
      "dec_cgst", //7
      "dec_sgst", //8
      "dec_igst", //9
      "dec_grandtotal", //10
      "dec_roundoff", //11
      "dec_totalamount", //12
      "vac_remark", //13
      "bint_acid", //14
      "vac_company", //15
    ],
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Order List";
    this.props.setActiveMenu("OrderList");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  NavigateToOrderEntry = (bint_acid, bint_ordersrno, bint_acyear) => {
    this.props.navigateTo("OrderEntry", {
      bint_acid: bint_acid,
      bint_ordersrno: bint_ordersrno,
      bint_acyear: bint_acyear,
    });
  };

  handleARDonActionClick = (row) => {
    const bint_acid = row.bint_acid,
      bint_ordersrno = row.bint_ordersrno,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName;
    if (actionName === "Edit") {
      // this.props.navigateTo(
      //   "OrderEntry/:" + bint_acid + ":" + bint_ordersrno + ":" + bint_acyear
      // );
      this.NavigateToOrderEntry(bint_acid, bint_ordersrno, bint_acyear);
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Order No. : " + bint_ordersrno + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteOrderList(
                bint_acid,
                bint_ordersrno,
                bint_acyear
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rowsCount > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.bint_ordersrno.length === 0 ||
            (row["bint_ordersrno"] &&
              row["bint_ordersrno"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.bint_ordersrno.toLowerCase()
                ))) &&
          (this.state.searchData.dat_orderdateDMY.length === 0 ||
            (row["dat_orderdateDMY"] &&
              row["dat_orderdateDMY"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dat_orderdateDMY.toLowerCase()
                ))) &&
          (this.state.searchData.vac_customer.length === 0 ||
            (row["vac_customer"] &&
              row["vac_customer"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_customer.toLowerCase()))) &&
          (this.state.searchData.vac_ledgername.length === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgername.toLowerCase()
                ))) &&
          (this.state.searchData.dec_totalamount.length === 0 ||
            (row["dec_totalamount"] &&
              row["dec_totalamount"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_totalamount.toLowerCase()
                ))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnCusDateWiseSalesClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<CustomerDateWiseSales />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleOnNewEntryClick = () => {
    this.props.navigateTo("OrderEntry");
  };

  validatOrder = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    if (this.validatOrder()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "OrderList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchOrder(reqData)
          .then((res) => {
            let rows = this.addActionColStatus(res.data.OrderList),
              rowsCount = rows.length;
            this.setState({
              dataLoadStatus: true,
              rows,
              rowsCount,
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  DisableOnEditDelete = (int_status, returnStatus = undefined) => {
    let DisableDelete = false;
    if (int_status == 0) {
      DisableDelete = false;
    } else {
      DisableDelete = true;
    }
    if (returnStatus) {
      return {
        DisableDelete,
      };
    } else {
      this.setState(
        {
          DisableDelete,
        },
        () => {}
      );
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Order",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  onFormLoad = () => {
    // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
    //   dtpToDate = get_YMD_from_SYS(new Date());
    const { fromdate, todate } = getlocalstoragedate("Order");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "bint_ordersrno",
        label: "Order No",
        value: this.state.searchData.bint_ordersrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "dat_orderdateDMY",
        items: this.state.BillType,
        label: "Date",
        value: this.state.searchData.dat_orderdateDMY,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "20",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_customer",
        label: "Customer",
        value: this.state.searchData.vac_customer,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        label: "Reference Name",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        label: "Delivery person Name",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        label: "Discount Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "CGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "SGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "IGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Grand Total",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Round Off",
        width: "100",
      },

      {
        cType: "CtTxt",
        id: "dec_totalamount",
        label: "Total Amount",
        value: this.state.searchData.dec_totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "bint_acid",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "vac_company",
        width: "100",
      }
    );
    this.setState({ searchColumns }, () => {
      // console.log(this.state.searchColumns);
    });
  };

  addActionColStatus = (rows) => {
    const newRows = rows.map((row) => {
      const actionStatus = this.DisableOnEditDelete(row.int_status, true);
      return {
        ...row,
        DisableDelete: actionStatus.DisableDelete,
      };
    });
    return newRows;
  };

  deleteOrderList = (bint_acid, bint_ordersrno, bint_acyear) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteOrder",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_ordersrno: bint_ordersrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
      };
      fetchOrder(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            let rows = this.addActionColStatus(res.data.OrderList);
            this.setState(
              {
                rows,
                dataLoadStatus,
              },
              () => {}
            );
          }
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in onFormLoad. " + error
          );
        });
    });
    return true;
  };

  //#endregion handle

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Order List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"dtpToDate"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // nextCtrlID={"btnLoad"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>

              <Grid item>
                <CtBtn id="btnLoad" label="Load" onClick={this.getInfo} />
              </Grid>
              {/* <Grid item>
                <CtBtn
                  label="To Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // nextCtrlID={"btnLoad"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Order Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(OrderList))));
